<template lang="pug">
slot(:filterTags="filterTags")
</template>

<script setup lang="ts">
import useFilterTags from '../lib/useFilterTags';

const filterTags = items => {
  return useFilterTags()(items);
};
</script>
